module.exports = __webpack_public_path__ + "static/media/MyHR-Icon.896db12c.png";